export default "__VITE_ASSET__BmVXth7I__"